var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./task.constants";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, create = _a.create, update = _a.update, remove = _a.remove, addMembers = _a.addMembers, removeMembers = _a.removeMembers, archive = _a.archive, unarchive = _a.unarchive;
export var getAccountContactInfo = function (params) {
    var taskId = params.taskId, accountId = params.accountId;
    return api.get("/tasks/".concat(taskId, "/members/").concat(accountId, "/light-contact-info"), { isV2: true });
};
